<template>
  <div class="group codegroup">
    <h3>{{ $t("modal.copy.title1") }}</h3>
    <div class="wrappercode">
      <button
        role="region"
        id="codeCopyStatus1"
        aria-live="polite"
        type="button"
        class="copycode"
        @click.stop.prevent="copy"
      >
        <template v-if="codeWasCopied">{{ $t("modal.copy.clipboardSuccess") }}</template>
        <template v-else>{{ $t("modal.copy.clipboard") }}</template>
      </button>

      <div id="code" ref="code">
          <p>
            <span class="cname">.parent</span> {
            <br>
            <span class="sp">
              <span class="ckey">display</span>:
              <span class="cprop">grid</span>;
            </span>
            <br>
            <span class="sp">
              <span class="ckey">grid-template-columns</span>:
              <span class="cprop">{{ colTemplate }}</span>;
            </span>
            <br>
            <span class="sp">
              <span class="ckey">grid-template-rows</span>:
              <span class="cprop">{{ rowTemplate }}</span>;
            </span>
            <br>
            <span class="sp">
              <span class="ckey">grid-column-gap</span>:
              <span class="cprop">{{ columngap }}px;</span>
            </span>
            <br>
            <span class="sp">
              <span class="ckey">grid-row-gap</span>:
              <span class="cprop">{{ rowgap }}px</span>;
            </span> 
            <br>}
          </p>
          <p>
            <span v-if="childarea.length > 0">
              <span v-for="(child, i) in childarea" :key="child">
                <span>
                  <span class="cname">.div{{ i + 1 }}</span> {
                  <span class="ckey">grid-area</span>:
                  <span class="cprop">{{ child }}</span>; }
                </span>
                <br>
              </span>
            </span>
          </p>
      </div>
      <!--code-->
    </div>
    <h3>{{ $t("modal.copy.title2") }}</h3>
    <div class="wrappercode">
      <button
        role="region"
        id="codeCopyStatus2"
        aria-live="polite"
        type="button"
        class="copycode"
        @click.stop.prevent="copy2"
      >
        <template v-if="codeWasCopied2">{{ $t("modal.copy.clipboardSuccess") }}</template>
        <template v-else>{{ $t("modal.copy.clipboard") }}</template>
      </button>
      <div id="code2" ref="code2">
      <p>
        &lt;<span class="cname">div </span>
        <span class="cprop">class="parent"</span>&gt;
        <br>
        <span v-if="childarea.length > 0">
          <span v-for="(child, i) in childarea" :key="child">
            <span class="sp">
              &lt;<span class="cname">div</span>
              <span class="cprop">&nbsp;class="div{{ i + 1 }}"</span>&gt;
              &lt;/<span class="cname">div</span>&gt;
            </span>
            <br>
          </span>
        </span>
        <span v-else>
          <br>
        </span>
        &lt;/<span class="cname">div</span>&gt;
      </p>
      </div>
    </div>
    <br>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  data() {
    return {
      codeWasCopied: false,
      codeWasCopied2: false,
      showHtml: false
    };
  },
  computed: {
    ...mapState(["columngap", "rowgap", "childarea"]),
    ...mapGetters(["rowTemplate", "colTemplate"])
  },
  methods: {
    copy() {
      let text = this.$refs.code,
        range,
        selection;

      if (document.body.createTextRange) {
        range = document.body.createTextRange();
        range.moveToElementText(text);
        range.select();
      } else if (window.getSelection) {
        selection = window.getSelection();
        range = document.createRange();
        range.selectNodeContents(text);
        selection.removeAllRanges();
        selection.addRange(range);
      }

      let copied = document.execCommand("copy");

      if (copied) {
        this.codeWasCopied = true;
        setTimeout(() => {
          this.codeWasCopied = false;
        }, 2000);
      }
    },
    copy2() {
      let text = this.$refs.code2,
        range,
        selection;

      if (document.body.createTextRange) {
        range = document.body.createTextRange();
        range.moveToElementText(text);
        range.select();
      } else if (window.getSelection) {
        selection = window.getSelection();
        range = document.createRange();
        range.selectNodeContents(text);
        selection.removeAllRanges();
        selection.addRange(range);
      }

      let copied = document.execCommand("copy");

      if (copied) {
        this.codeWasCopied2 = true;
        setTimeout(() => {
          this.codeWasCopied2 = false;
        }, 2000);
      }
    },
    toggleHtml() {
      this.showHtml = !this.showHtml;
    }
  }
};
</script>

<style lang="scss" scoped>
.wrappercode {
  position: relative;
  background: #1e1e1e;
  padding: 16px;
  border: 1px solid #444;
  font-size: 15px;
  font-family: "Roboto Mono", Courier, monospace;
  max-height: 50vh;
  overflow-y: scroll;
  p {
    margin: 5px;
  }
}

.copycode {
  position: absolute;
  right: 0;
  top: 0;
  margin: 0;
  font-size: 14px;
  padding: 4px 10px;
  cursor: pointer;
}

.child {
  padding-left: 40px;
}

.sp {
  padding-left: 20px;
}

.ckey {
  color: #72e0d1;
}

.cprop {
  color: #fc9463;
}
.cname {
  color: #f5d67b;
}
</style>
